<script lang="ts">
  import { isUserRoleADM, isUserRoleVET, isUserRoleQCC } from "../../app.store";
  import MainMenuItem from "./MainMenuItem.svelte";
</script>

<div class="main-menu noselect">
  <aside class="menu">
    {#if $isUserRoleADM}
      <p class="menu-label">Generale</p>
      <ul class="menu-list">
        <MainMenuItem link="/customer" label="Anagrafiche" icon="group" />
        <MainMenuItem link="/transport-document" label="DDT" icon="local_shipping" />
        <MainMenuItem link="/traceability" label="Tracciabilità" icon="route" />
        <!--
        <MainMenuItem link="/pdf-test" label="PDF Test" icon="system_update_alt" />
        -->
      </ul>

      <!--
    <p class="menu-label">Allevamento</p>
    <ul class="menu-list">
      <MainMenuItem link="/farm-load" label="Forniture" icon="input" />
      <MainMenuItem link="/farm-exit" label="Scarico" icon="output" />
    </ul>
    -->

      <p class="menu-label">Macellazione</p>
      <ul class="menu-list">
        <!-- <MainMenuItem link="/butcher-ingredients" label="Ingresso ingredienti" icon="system_update_alt" /> -->
        <MainMenuItem link="/butcher-work/slaughter" label="Programma" icon="settings_suggest" />
        <!-- icon was 'scale' -->
        <MainMenuItem link="/butcher-entrance" label="Ingresso capi" icon="label" />
        <!-- <MainMenuItem link="/butcher-weight-label" label="Etichette" icon="label" />  -->
        <MainMenuItem link="/butcher-visits" label="Visite" icon="toc" />
        <!-- <MainMenuItem link="/butcher-sales" label="Vendite" icon="shopping_cart" /> -->
        <MainMenuItem link="/butcher-visit-history" label="Storico Macellazioni" icon="toc" />
      </ul>

      <p class="menu-label">Sezionamento</p>
      <ul class="menu-list">
        <MainMenuItem link="/butcher-work/section" label="Programma" icon="settings_suggest" />
      </ul>

      <p class="menu-label">Trasformazione</p>
      <ul class="menu-list">
        <MainMenuItem link="/butcher-work/transform" label="Programma" icon="settings_suggest" />
        <MainMenuItem link="/product-type" label="Prodotti" icon="restaurant_menu" />
        <MainMenuItem link="/recipe" label="Ricette" icon="import_contacts" />
        <MainMenuItem link="/butcher-ingredients" label="Ingredienti" icon="whatshot" />
        <MainMenuItem link="/butcher-materials" label="Materiali" icon="gesture" />
      </ul>

      <p class="menu-label">Qualità</p>
      <ul class="menu-list">
        <MainMenuItem link="/quality-manual" label="Manuale" icon="menu_book" />
        <MainMenuItem link="/quality-procs" label="Procedure" icon="workspace_premium" />
      </ul>

      <p class="menu-label">Amministrazione</p>
      <ul class="menu-list">
        <MainMenuItem link="/user" label="Utenti" icon="person" />
        <MainMenuItem link="/settings" label="Impostazioni" icon="settings" />
      </ul>
    {/if}

    {#if $isUserRoleVET}
      <p class="menu-label">Macellazione</p>
      <ul class="menu-list">
        <MainMenuItem link="/butcher-visits" label="Visite" icon="toc" />
        <MainMenuItem link="/butcher-visit-history" label="Storico Macellazioni" icon="toc" />
      </ul>

      <!-- DISABLED FOR NOW -->
      <!--
      <p class="menu-label">Qualità</p>
      <ul class="menu-list">
        <MainMenuItem link="/quality-main" label="Qualità" icon="workspace_premium" />
      </ul>
      -->
    {/if}

    {#if $isUserRoleQCC}
      <p class="menu-label">Qualità</p>
      <ul class="menu-list">
        <MainMenuItem link="/quality-manual" label="Manuale" icon="menu_book" />
        <MainMenuItem link="/quality-procs" label="Procedure" icon="workspace_premium" />
      </ul>
    {/if}
  </aside>
</div>

<style>
  .main-menu .menu-label:not(:last-child) {
    margin-bottom: 0.25em;
  }
</style>
